var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none",
    viewBox: "0 0 15 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.967c-2.253 0-4.076-1.782-4.076-3.983S5.26 0 7.499 0c2.24 0 4.076 1.782 4.076 3.984S9.752 7.967 7.499 7.967m0-6.694c-1.524 0-2.774 1.222-2.774 2.71 0 1.49 1.25 2.712 2.773 2.712s2.774-1.222 2.774-2.711c0-1.49-1.25-2.711-2.774-2.711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.349 14H0v-.637c0-3.627 3.36-6.58 7.5-6.58s7.5 2.953 7.5 6.58V14zM1.341 12.727H13.66c-.365-2.635-2.995-4.684-6.159-4.684s-5.794 2.05-6.159 4.684"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v14H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Profil.db5f0bd2d9d2f798fcdfc7e02d0c70f9.svg";